module.exports = __webpack_public_path__ + "static/media/Ku_Indonesia.462751a5.png";